(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdt-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(stage) {
      var slides = stage.querySelectorAll('[data-cdt-hero-slide]');
      var dots = stage.querySelectorAll('[data-cdt-hero-dot]');
      if (slides.length < 2) return;
      var i = 0;
      var timer = null;

      function show(n) {
        i = (n + slides.length) % slides.length;
        for (var k = 0; k < slides.length; k++) {
          slides[k].classList.toggle('is-active', k === i);
          if (dots[k]) {
            dots[k].classList.toggle('is-active', k === i);
            dots[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
          }
        }
      }

      for (var d = 0; d < dots.length; d++) {
        (function (n) {
          dots[n].addEventListener('click', function () { show(n); restart(); });
        })(d);
      }

      var seconds = parseInt(stage.getAttribute('data-cdt-hero-auto'), 10);
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function restart() {
        if (timer) clearInterval(timer);
        if (!seconds || reduced) return;
        timer = setInterval(function () {
          if (document.hidden) return;
          show(i + 1);
        }, seconds * 1000);
      }
      restart();
    }

    function init() {
      var stages = document.querySelectorAll('[data-cdt-hero]');
      for (var s = 0; s < stages.length; s++) setup(stages[s]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
